import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Divider, List, Typography } from '@mui/material';

// project imports
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const NavGroup = ({ item }) => {
  const theme = useTheme();

  // menu list collapse & items
  const items = item.children?.flatMap((menu) => {
    let element;
    switch (menu.type) {
      case 'collapse':
        element = <NavCollapse key={menu.id} menu={menu} level={1} />;
        break;
      case 'item':
        element = <NavItem key={menu.id} item={menu} level={1} />;
        break;
      default:
        element = (
          <Typography key={menu.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
        break;
    }
    
    // 在dashboard和history菜单项后面添加分界线
    if (menu.id === 'dashboard' || menu.id === 'history') {
      return [element, <Divider key={`${menu.id}-divider`} sx={{ my: 0.5, mx: 2, bgcolor: 'rgba(0, 0, 0, 0.5)' }} />];
    }
    
    return [element];
  });

  return (
    <>
      <List
        subheader={
          item.title && (
            <Typography variant="caption" sx={{ ...theme.typography.menuCaption }} display="block" gutterBottom>
              {item.title}
              {item.caption && (
                <Typography variant="caption" sx={{ ...theme.typography.subMenuCaption }} display="block" gutterBottom>
                  {item.caption}
                </Typography>
              )}
            </Typography>
          )
        }
      >
        {items}
      </List>

      {/* group divider */}
      <Divider sx={{ mt: 0.25, mb: 1.25 }} />
    </>
  );
};

NavGroup.propTypes = {
  item: PropTypes.object
};

export default NavGroup;
